module.exports = __webpack_public_path__ + "img/home_bg.e5c69596.png";